import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import "./App.css";
import Home from "./pages/Home";
import About from "./pages/About";
import Careers from "./pages/Careers";
import Contact from "./pages/Contact";
import Tofuemail from "./pages/Tofuemail";
import Tofuinent from "./pages/Tofuinent";
import Contentsyndi from "./pages/Contentsyndi";
import Displaymarketing from "./pages/Displaymarketing";
import Moumarketingqul from "./pages/Moumarketingqul";
import Mouhql from "./pages/Mouhql";
import Moubant from "./pages/Moubant";
import Mouwebinar from "./pages/Mouwebinar";
import Bofuappoin from "./pages/Bofuappoin";
import Bofusql from "./pages/Bofusql";
import Faq from "./pages/Faq";
import Privacypolicy from "./pages/Privacypolicy";
import Dncpolicy from "./pages/dncpolicy";
import Gdprpolicy from "./pages/gdprpolicy";
import Blog1D from "./pages/Blog1D";
import Blog2D from "./pages/Blog2D";
import Blog3D from "./pages/Blog3D";
import Blog4D from "./pages/Blog4D";
import Blog5D from "./pages/Blog5D";
import Blog6D from "./pages/Blog6D";
import Blog7D from "./pages/Blog7D";
import Blogs from "./pages/Blogs";
import Whitepapers from "./pages/Whitepapers";
import Whitepapers1 from "./pages/Whitepapers1";
import Whitepapers2 from "./pages/Whitepapers2";
import Whitepapers3 from "./pages/Whitepapers3";
import Whitepapers4 from "./pages/Whitepapers4";
import Loader from "./components/Loader";
import CookieConsent from "./components/CookieConsent";
import usePageTracking from "./hooks/usePageTracking";
import Services from "./pages/Services";

function App() {
  return (
    <Router>
      {/* RouteChangeLoader and PageTracking are now inside the Router */}
      <AppContent />
    </Router>
  );
}

// ✅ Move hooks inside this component so they have Router context
function AppContent() {
  usePageTracking();
  return (
    <>
     
      <RouteChangeLoader />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/tofuemail" element={<Tofuemail />} />
        <Route path="/tofuinent" element={<Tofuinent />} />
        <Route path="/contentsyndi" element={<Contentsyndi />} />
        <Route path="/displaymarketing" element={<Displaymarketing />} />
        <Route path="/moumarketingqul" element={<Moumarketingqul />} />
        <Route path="/mouhql" element={<Mouhql />} />
        <Route path="/moubant" element={<Moubant />} />
        <Route path="/mouwebinar" element={<Mouwebinar />} />
        <Route path="/bofuappoin" element={<Bofuappoin />} />
        <Route path="/bofusql" element={<Bofusql />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/privacypolicy" element={<Privacypolicy />} />
        <Route path="/gdprpolicy" element={<Gdprpolicy />} />
        <Route path="/dncpolicy" element={<Dncpolicy />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blog1D" element={<Blog1D />} />
        <Route path="/blog2D" element={<Blog2D />} />
        <Route path="/blog3D" element={<Blog3D />} />
        <Route path="/blog4D" element={<Blog4D />} />
        <Route path="/blog5D" element={<Blog5D />} />
        <Route path="/blog6D" element={<Blog6D />} />
        <Route path="/blog7D" element={<Blog7D />} />
        <Route path="/whitepapers" element={<Whitepapers />} />
        <Route path="/whitepapers1" element={<Whitepapers1 />} />
        <Route path="/whitepapers2" element={<Whitepapers2 />} />
        <Route path="/whitepapers3" element={<Whitepapers3 />} />
        <Route path="/whitepapers4" element={<Whitepapers4 />} />
      </Routes>

      {/* 👇 Cookie banner shown across all pages */}
      <CookieConsent />
    </>
  );
}

// ✅ RouteChangeLoader now inside Router, so useLocation() works fine
function RouteChangeLoader() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => setLoading(false), 3000);
    return () => clearTimeout(timeout);
  }, [location]);

  return loading ? <Loader /> : null;
}

export default App;
